import classnames from "classnames";
import {PropsWithChildren} from "react";

import {Alert} from "@/components/alert/Alert.tsx";
import {AlertVariant} from "@/components/alert/Alert.types.ts";
import {PropsWithClassName} from "@/lib/types/props.ts";

interface UpsellAlertProps extends PropsWithChildren, PropsWithClassName {
  title: string;
  title_cont?: string;
  dismissable?: boolean;
  alertVariant?: AlertVariant;
}

export const UpsellAlert = ({
  title,
  className,
  title_cont,
  children,
  alertVariant = "verification",
  dismissable = true,
}: UpsellAlertProps) => (
  <Alert
    dismissible={dismissable}
    variant={alertVariant}
    className={classnames("mb-3", className)}
    callout={
      <>
        <span>{title}</span> {title_cont}
      </>
    }
  >
    {children}
  </Alert>
);
